import api from './api';

const userService = {
    /**
     * Kullanıcı bilgilerini getirir (Key üzerinden)
     * @param {string} activationCode
     * @returns {Promise<Object>} Kullanıcı bilgileri
     */
    getUserFromKey: async (activationCode) => {
        try {
            const response = await api.post('user/GetUserFromKey', {
                ActivationCode: activationCode
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Kullanıcı bilgilerini günceller
     * @param {Object} userData - Güncellenecek kullanıcı verileri
     * @returns {Promise<any>}
     */
    updateUser: async (userData) => {
        try {
            const response = await api.post('user', userData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Şifre değiştirme
     * @param {Object} passwordData - { oldPass, newPass, ... }
     * @returns {Promise<any>}
     */
    changePassword: async (passwordData) => {
        try {
            const response = await api.post('Login/ChangePassword', passwordData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Şifremi unuttum
     * @param {string} email 
     * @returns {Promise<any>}
     */
    forgotPassword: async (email) => {
        try {
            const response = await api.post('login/forgotpassword', { eposta: email });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Yeni üye ekleme
     * @param {Object} memberData 
     * @returns {Promise<any>}
     */
    addMember: async (memberData) => {
        try {
            const response = await api.post('user/addmember', memberData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Hesap aktivasyonu
     * @param {Object} activationData - { key: ... }
     * @returns {Promise<any>}
     */
    activateUser: async (activationData) => {
        try {
            const response = await api.post('user/activationUser/activate', activationData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Aktivasyon mailini tekrar gönderir
     * @param {string} email
     * @returns {Promise<any>}
     */
    resendActivation: async (email) => {
        try {
            const response = await api.post('user/resendactivation', { eposta: email });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * E-posta adresinin kullanımda olup olmadığını kontrol eder
     * @param {string} email
     * @returns {Promise<boolean>} true: kullanımda, false: müsait (API dönüşüne göre değişebilir, genellikle obje veya boolean döner)
     */
    checkEmail: async (email) => {
        try {
            // API yolu: /api/User/CheckEmail/{email}
            const response = await api.get(`User/CheckEmail/${email}`);
            return response.data;
        } catch (error) {
            console.error("E-posta kontrol hatası:", error);
            return false; // Hata durumunda akışı bozmamak için false dönüyoruz, ama logluyoruz.
        }
    },

    /**
     * İndirilen dosyaların listesini getirir
     * @param {string|number} userId - Kullanıcı ID
     * @returns {Promise<Array>} İndirilen dosyalar listesi
     */
    getDownloadedFiles: async (userId) => {
        try {
            const response = await api.get(`Downloaded/${userId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default userService;
